import { Clock, Mail, MapPin, Phone } from "lucide-react";

// Lucide-Icons im Stil des Designs (16px, leicht transparent, dekorativ).
const iconProps = {
    size: 16,
    strokeWidth: 1.75,
    "aria-hidden": true,
    className: "flex-none opacity-70",
};

export const PhoneIcon = () => <Phone {...iconProps} />;
export const MailIcon = () => <Mail {...iconProps} />;
export const MapPinIcon = () => <MapPin {...iconProps} />;
export const ClockIcon = () => <Clock {...iconProps} />;
